module.exports = __webpack_public_path__ + "img/20210704_144851.633db110.jpg";